;(function () {
  'use strict'

  angular
    .module('contrast.security-controls')
    .controller(
      'ControlServerModalInstanceCtrl',
      ControlServerModalInstanceCtrl
    )

  function ControlServerModalInstanceCtrl(
    $scope,
    $uibModalInstance,
    servers,
    org
  ) {
    'ngInject'

    angular.extend($scope, {
      servers: servers,
      org: org
    })

    angular.extend($scope, {
      close: close
    })

    function close() {
      $uibModalInstance.dismiss('cancel')
    }
  }
})()
